import { apiClient } from '@/lib/api-client';
import { API_ENDPOINTS, UserDetails } from '@/types/api';

export interface UpdateProfileData {
  name?: string;
  phone?: string;
  country?: string;
  avatar?: string;
  onboarding_step?: number;
}

export const usersApi = {
  // Get current user details
  getMe: async (): Promise<UserDetails> => {
    return apiClient.get<UserDetails>(API_ENDPOINTS.users.me);
  },
  
  // Update user profile
  updateProfile: async (data: UpdateProfileData): Promise<UserDetails> => {
    return apiClient.patch<UserDetails>(API_ENDPOINTS.users.me, data);
  },
};